export type HotEditElementKind =
  | 'container'
  | 'text'
  | 'icon'
  | 'image'
  | 'formControl'
  | 'action'
  | 'unsupported';

export type HotEditPropSection =
  | 'typography'
  | 'size'
  | 'layout'
  | 'box'
  | 'spacing'
  | 'border'
  | 'radius'
  | 'content'
  | 'form';

const TEXT_TAGS = new Set(['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span', 'label', 'a', 'strong', 'em']);

const UNSUPPORTED_TAGS = new Set([
  'script',
  'style',
  'noscript',
  'iframe',
  'canvas',
  'video',
  'audio',
]);

const CONTAINER_WITHOUT_FIBER_TAGS = new Set([
  'div',
  'main',
  'section',
  'article',
  'footer',
  'header',
  'nav',
  'form',
  'ul',
  'ol',
]);

export function classifyElementKind(opts: {
  tagName: string;
  hasChildElements: boolean;
  fiberChainLength: number;
  contentEditable: boolean;
}): HotEditElementKind {
  const t = opts.tagName;
  if (UNSUPPORTED_TAGS.has(t)) return 'unsupported';
  const hasFib = opts.fiberChainLength > 0;

  /** Third-party rich text */
  if (opts.contentEditable && t !== 'input' && t !== 'textarea') return 'unsupported';

  if (t === 'img') return 'image';
  if (t === 'svg') return 'icon';

  if (t === 'button') return 'action';
  if (t === 'input' || t === 'textarea' || t === 'select') return 'formControl';

  if (!hasFib && !CONTAINER_WITHOUT_FIBER_TAGS.has(t)) return 'unsupported';

  if (TEXT_TAGS.has(t) && !opts.hasChildElements && hasFib) return 'text';

  if (!opts.hasChildElements && hasFib && !['img', 'svg'].includes(t)) return 'text';

  return 'container';
}

export function getEditableSections(kind: HotEditElementKind): HotEditPropSection[] {
  switch (kind) {
    case 'container':
      return ['size', 'box', 'layout', 'spacing', 'border', 'radius'];
    case 'text':
      return ['content', 'typography', 'size', 'spacing'];
    case 'icon':
      return ['size', 'box'];
    case 'image':
      return ['size'];
    case 'formControl':
      return ['form', 'typography', 'size', 'spacing', 'border', 'box'];
    case 'action':
      return ['content', 'typography', 'size', 'layout', 'spacing', 'border', 'radius', 'box'];
    default:
      return [];
  }
}
